<template>
  <aside
    class="main-sidebar animated"
    :class="{ expandSide: !sidebar.collapsed }"
  >
    <el-scrollbar wrapClass="vue-scrollbar" tag="div">
      <div class="sidebar">
        <el-menu
          :default-active="onRoutes"
          class="el-menu-style"
          theme="light"
          router
          :collapse="sidebar.collapsed"
        >
          <sub-menu
            v-for="route in routers"
            :key="route.name"
            :item="route"
            :base-path="route.path"
            class="sub-menu"
          ></sub-menu>
        </el-menu>
      </div>
    </el-scrollbar>
  </aside>
</template>
<script>
import subMenu from "./subMenu";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import router from "../../../router";
export default {
  components: {
    subMenu,
  },
  computed: {
    /*...mapGetters([
            'menuList',
            'sidebar',
            'routers'
        ]),*/
    ...mapState({
      menuList: (state) => state.menuList,
      sidebar: (state) => state.sidebar,
      routers: (state) => {
        let arr = state.routers.slice(0);

        if (window.localStorage.getItem("agent_type") === "管理员") {
          var newArr = [];
          arr.forEach((item, index) => {
            if (item.name == "渠道包下载" || item.name == "提现管理") {
            } else {
              newArr.push(item);
            }
          });
          return newArr;
        }
        else {
          var newArr = [];
          arr.forEach((item, index) => {
            if (window.localStorage.getItem("agent_type") === "三级代理") {
              console.log(item.name);
              if (item.name != "代理商管理"&&item.name != "管理员") {
                newArr.push(item);
              }
            } else {
              if (item.name != "管理员") {
                newArr.push(item);
              }
            }
          });
          return newArr;
        }
      },
    }),
    onRoutes() {
      let path = "";

      if (this.$route.path == "/officialNews") {
        path = "/index";
        return path;
      } else if (this.$route.path == "/newInternetBar") {
        path = "/netbarmanage";
        return path;
      } else {
        return this.$route.path;
      }
    },
  },
  created() {
    console.log(this.routers);
    //   debugger
  },
  methods: {
    ...mapActions({
      load: "GenerateRoutes",
    }),
  },
};
</script>

<style lang="scss">
.showSlide {
  animation-duration: 0.2s;
  animation-name: slideInLeft;
}
.hideSlide {
  animation-duration: 0.2s;
  animation-name: slideOutLeft;
}

.main-sidebar {
  background-color: #ffffff;
  position: fixed;
  top: 50px;
  left: 0;
  bottom: 0;
  height: calc(100vh - 20px);
  width: 62px;
  z-index: 810;
  -webkit-transition: -webkit-transform 0.3s ease-in-out, width 0.3s ease-in-out;
  -moz-transition: -moz-transform 0.3s ease-in-out, width 0.3s ease-in-out;
  -o-transition: -o-transform 0.3s ease-in-out, width 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
  .el-scrollbar__bar.is-vertical {
    display: none;
  }
  &.expandSide {
    width: 280px;
  }
  .el-menu--collapse {
    width: 62px !important;
    font-size: 16px !important;
    .el-menu-item,
    .el-submenu > .el-submenu__title {
      padding-left: 13px !important;
      width: 24px;
      margin: 0;
      text-align: center;
      vertical-align: middle;
    }

    .el-submenu .el-submenu__title .el-submenu__icon-arrow {
      // display: none;
      right: 40px !important;
    }
    .el-icon-arrow-down {
      right: 40px !important;
    }
    .el-tooltip {
      width: 50% !important;
      padding: 0 10px !important;
    }
  }
  .vue-scrollbar {
    background-color: #ffffff;
    height: calc(100vh -50px);
    .sidebar {
      min-height: 700px;
      .el-menu-style .el-menu-item {
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        padding: 0 40px !important;
      }
      .el-menu-style .el-menu-item,
      .el-menu-style .el-submenu__title {
        font-size: 16px;
        padding: 0 31px !important;
        height: 60px;
        line-height: 60px;
        .el-icon-arrow-down{
          right: 40px;
        }
      }
      .el-menu--inline .el-menu-item{
        padding-left: 60px!important;
      }
    }
  }
}
</style>

